import { FC } from "react";
import styles from "./styles.module.scss";

import { ICONS } from "assets";

const Wrapper: FC = () => {
  return (
    <div className={styles.wrapper}>
      <ICONS.Filter />
    </div>
  );
};

export default Wrapper;
